module.exports = __webpack_public_path__ + "img/20220413_122943.bd989df4.jpg";